import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "importBtn", "importCount"]

  connect() {
    this.updateCount()
  }

  updateCount() {
    const count = this.checkboxTargets.filter(cb => cb.checked).length
    this.importCountTargets.forEach(el => { el.textContent = count })
    if (this.hasImportBtnTarget) {
      this.importBtnTarget.disabled = count === 0
    }
  }

  selectAll() {
    this.checkboxTargets.forEach(cb => { cb.checked = true })
    this.updateCount()
  }

  selectNone() {
    this.checkboxTargets.forEach(cb => { cb.checked = false })
    this.updateCount()
  }
}
